<div class="row justify-content-center" [ngClass]="routeAnimationsElements">
  <div class="col-md-8">
    <mat-card>
      <rpe-muestreador-form [formInput]="formInput" (formValueChanges)="formValueChanges($event)"
        (formStatusChanges)="formStatusChanges($event)"></rpe-muestreador-form>
      <div class="row buttons d-flex justify-content-between pad" [ngClass]="routeAnimationsElements">
        <button type="reset" (click)="onCancel()" mat-raised-button>
          {{ 'rpe.vista-usuario.cancelar' | translate }}
        </button>
        <button type="submit" mat-raised-button (click)="onSubmit()" color="primary">
          {{ 'rpe.vista-usuario.confirmar' | translate }}
        </button>
      </div>
    </mat-card>
  </div>
</div>
